var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextPapersStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42.792px",
    height: "42.792px",
    viewBox: "0 0 42.792 42.792",
    style: {
      enableBackground: "new 0 0 42.792 42.792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.792,13.986L30.243,2.336L26.325,5.19l-4.417-4.101L0,17.039L7.229,32.56l2.125-1.547l5.042,10.689L41.59,21.906 l-4.175-4.007L42.792,13.986z M30.012,6.215l8.066,7.488L16.72,29.25l-1.293-2.661l19.027-13.851l-5.892-5.47L30.012,6.215z  M3.76,18.009L21.674,4.969l8.068,7.489L8.409,27.988L3.76,18.009z M36.928,21.589L15.562,37.142l-3.738-7.929l1.141-0.83 l2.625,5.402L34.953,19.69L36.928,21.589z M12.92,13.811l4.332,5.951l-2.426,1.765l-4.332-5.949L12.92,13.811z M16.258,11.379 l4.333,5.951l-2.424,1.766l-4.333-5.951L16.258,11.379z M23.93,14.901l-2.426,1.766l-4.333-5.95l2.425-1.767L23.93,14.901z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextPapersStack);
export default __webpack_public_path__ + "static/media/text-papers-stack.67b4485d9b3748f9881840f96fc8f7da.svg";
export { ForwardRef as ReactComponent };